import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { TutorPage } from "@/components/tutor/tutor-page";
import { requireRole } from "@/lib/session";

export const Route = createFileRoute("/learner/tutor")({
  ssr: false,
  beforeLoad: () => requireRole("learner"),
  head: () => ({ meta: [{ title: "MAKAI Tutor · MAKAI" }] }),
  component: Page,
});

function Page() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const isThreadRoute = pathname.startsWith("/learner/tutor/");

  if (isThreadRoute) return <Outlet />;

  return (
    <AppShell role="learner" title="MAKAI Tutor" subtitle="Your personal learning companion">
      <TutorPage role="learner" />
    </AppShell>
  );
}
